<script>
  import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'
  let countDownTimerInit = 30
  export default{
    name: 'lote-leilao-stats',
    props: ['lote', 'leilao'],
    data () {
      return {
        countDownTimer: countDownTimerInit,
        hasNovoLance: false
      }
    },
    computed: {
      loteNumero () {
        if (this.lote.numero !== null && this.lote.numero !== 'null') {
          /* ('000' + String(this.lote.numero)).slice(-3) bug.. verificar em outras utilizações */
          let str = String(this.lote.numero)
          let pad = '000'
          return pad.substring(0, pad.length - str.length) + str
        }
        return 'N/LT'
      },
      lanceLocalidade () {
        return this.testHasProperty() ? this.lote.lancePrincipal.arrematante.pessoa.essencial.cidade + ' - ' + this.lote.lancePrincipal.arrematante.pessoa.essencial.uf : '-'
      },
      valor () {
        return this.testHasProperty() ? this.lote.lancePrincipal.valor : 0
      },
      apelido () {
        return this.testHasProperty() ? this.lote.lancePrincipal.arrematante.apelido : '-'
      },
      timerPregao () {
        if (typeof this.leilao['timerPregao'] === 'undefined') {
          return 30
        }
        return parseInt(+this.leilao.timerPregao)
      },
      timerPregaoFormatado () {
        let timer = Number(this.countDownTimer)
        if (timer < 60) {
          return '00:' + ('0' + timer).slice(-2)
        }
        let hora = Math.floor(timer / 60)
        let minutos = timer % 60
        return ('0' + hora).slice(-2) + ':' + ('0' + minutos).slice(-2)
      },
      Status () {
        return Status
      },
      statusLote () {
        if (this.lote.status === null) {
          return '-'
        }
        if (typeof this.Status.Status[this.lote.status] !== 'undefined') {
          return this.Status.Status[this.lote.status].titulo
        }
        return 'Status inválido'
      },
      colorStatus () {
        if (this.lote.status === null) {
          return '#FFFFFF'
        }
        if (typeof this.Status.Status[this.lote.status]['color'] !== 'undefined') {
          return this.Status.Status[this.lote.status]['color']
        }
        return '#FFFFFF'
      }
    },
    created () {
    },
    destroyed () {
    },
    methods: {
      testHasProperty () {
        return typeof this.lote.lancePrincipal !== 'undefined' && this.lote.lancePrincipal !== null && this.lote.lancePrincipal !== 'null'
      },
      reset () {
        this.countDownTimer = countDownTimerInit
      },
      mountTimerCountdown () {
        this.$nextTick(() => {
          console.log('Countdown execute...')
          if (typeof this.$intervalCronometro !== 'undefined') {
            window.clearInterval(this.$intervalCronometro)
            this.reset()
          }
          if (typeof this.lote.pregao === 'undefined') {
            console.log('Lote não está em pregão, por isso não inicia o cronômetro.')
            return
          }
          if (this.lote.pregao !== null) {
            console.log('Inicia os ajustes do cronômetro.', this.lote.pregao)
            // Pregão está ativo e cronômetro deve funcionar
            let dataInicio = new Date(this.lote.pregao.dataAbertura.date)

            // Se existe lance, pega a data do último lance, caso tenha sido efetuado depois do pregão ser ativo
            if (this.lote.lances.length > 0) {
              let dataUltimoLance = new Date(this.lote.lances[0].data.date)
              if (dataUltimoLance.getTime() >= dataInicio.getTime()) {
                // O lance efetuado foi durante o pregão ativo
                dataInicio = dataUltimoLance
              }
            } else {
              // Caso contrário, pega a data de abertura do pregão do lote
            }
            dataInicio.setSeconds(dataInicio.getSeconds() + this.timerPregao)
            let intervalFcn = () => {
              let dataFim = new Date().getTime()
              let distance = dataInicio.getTime() - dataFim
              let seconds = Math.floor(distance / 1000)

              if (distance < 1) {
                window.clearInterval(this.$intervalCronometro)
                this.countDownTimer = 0
              } else {
                this.countDownTimer = seconds
              }
            }
            intervalFcn()
            this.$intervalCronometro = window.setInterval(intervalFcn, 1000)
          }
        })
      },
      novoLance () {
        if (this.$timeOutAnimNovoLance) {
          window.clearTimeout(this.$timeOutAnimNovoLance)
        }
        this.hasNovoLance = true
        this.$nextTick(() => {
          window.setTimeout(() => {
            this.hasNovoLance = false
          }, 1)
        })
      }
    },
    components: {}
  }
</script>

<template>
  <div class="lote-leilao-stats">
    <div class="tab-lance-numlote">
      <div class="stats-title">Lote</div>
      <div class="stats-input">{{ loteNumero }}</div>
    </div>
    <div class="tab-lance-timer">
      <div class="stats-title">Tempo</div>
      <div class="stats-input lance-timer" :class="{'lance-danger': countDownTimer < 10}">{{ timerPregaoFormatado }}
      </div>
    </div>
    <div class="tab-valor-atual">
      <div class="stats-title">Valor atual</div>
      <div class="stats-input valor-atual" :class="{novoLance: hasNovoLance}">R$ {{ valor | moeda }}</div>
    </div>
    <div class="tab-ultimo-lance">
      <div class="stats-title">Último lance</div>
      <div class="stats-input ultimo-lance">
        <div>
          {{ apelido }}
          <span>{{ lanceLocalidade }}</span>
        </div>
      </div>
    </div>
    <div class="tab-status">
      <div class="stats-title">Status</div>
      <div class="stats-input lote-status s-pregao"><span :style="'color: ' + colorStatus">{{ statusLote }}</span>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// LoteLeilaoStats.vue?4660565a